import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { captureMessage } from '@sentry/angular';
import { MainLayoutComponent } from '../main-layout/main-layout.component';

@Component({
  selector: 'app-page-forbidden',
  templateUrl: './page-forbidden.component.html',
  styleUrls: ['./page-forbidden.component.scss'],
  standalone: true,
  imports: [MainLayoutComponent, MatIconModule, TranslatePipe],
})
export class PageForbiddenComponent implements OnInit {
  show = false;

  ngOnInit(): void {
    setTimeout(() => {
      this.show = true;
    }, 1000);
    captureMessage('User landed on 403, use breadcrumbs to investigate', 'error');
  }
}
